import React, { useState } from "react"
import { Col, Row } from "antd"
import ActivityCard from "./ActivityCard"
import { DownloadOutlined } from '@ant-design/icons'
import { pdf, Document, Image, View, Page } from '@react-pdf/renderer';
import domtoimage from 'dom-to-image';
import "./activityReport.css"
import moment from "moment"
import DateRange from "./DateRange";

function ActivityReport() {
  const [range, setRange] = useState<{ start: moment.Moment | null | undefined, end: moment.Moment | null | undefined }>({ start: null, end: null })

  const downloadPDF = (image: string) => (
    <Document title="rapport d'activite">
      <Page>
        <View >
          <Image src={image} />
        </View>
      </Page>
    </Document>
  )

  const download = async () => {
    const node = document.querySelector("#react-target > div > div.activity-report-main-div")
    if (node) {
      domtoimage.toBlob(node)
        .then(async function (blob) {
          let tmp = URL.createObjectURL(blob)
          let PDF = await pdf(downloadPDF(tmp)).toBlob()
          var a = document.createElement('a');
          a.href = URL.createObjectURL(PDF);
          const date = moment(new Date()).format("DD-MM-YYYY")
          a.download = "Rapport d'activité du " + date + ".pdf";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        })
        .catch(function (error) {
          console.error(error);
        });
    }
  }

  return (
    <div className="activity-report-main-div">
      <Row>
        <Col xs={4}>
          <h2 id='activity-report-title' className="activity-report-title">Rapport d'activité</h2>
        </Col>
        <Col xs={16}>
          <DateRange setRange={setRange} range={range} />
        </Col>
        <Col xs={4}>
          <span onClick={() => download()} className='edit-download'>
            <DownloadOutlined style={{ paddingRight: '0.5rem' }} />
            Telecharger
          </span>
        </Col>
      </Row>
      <div id={"Activity-card"} >
        <ActivityCard range={range} />
      </div>
    </div >
  )
}

export default ActivityReport